import { render, staticRenderFns } from "./CreateBantPopUp.vue?vue&type=template&id=72cd7c6d&scoped=true&"
import script from "./CreateBantPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateBantPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateBantPopUp.vue?vue&type=style&index=0&id=72cd7c6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd7c6d",
  null
  
)

export default component.exports